export default __webpack_public_path__ + "static/media/D4URS_FordOval_RGB_v2.b70d54a9.png";